export const categories = [
  {
    slug: 'entertainment',
    name: '娱乐视频',
    icon: 'ri-movie-2-line',
    description: '汇聚热门综艺、搞笑段子、明星动态，放松心情的最佳选择',
    color: 'accent',
  },
  {
    slug: 'education',
    name: '学习教育',
    icon: 'ri-book-open-line',
    description: '精选优质课程、知识科普、技能教程，随时随地提升自我',
    color: 'primary',
  },
  {
    slug: 'lifestyle',
    name: '生活技巧',
    icon: 'ri-lightbulb-line',
    description: '家居收纳、健康养生、理财妙招，让生活更精致美好',
    color: 'secondary',
  },
  {
    slug: 'tech',
    name: '科技数码',
    icon: 'ri-smartphone-line',
    description: '数码评测、科技资讯、互联网趋势，走在科技前沿',
    color: 'accent',
  },
  {
    slug: 'food',
    name: '美食烹饪',
    icon: 'ri-restaurant-line',
    description: '各地美食探店、家常菜教程、烘焙甜品，满足你的味蕾',
    color: 'primary',
  },
  {
    slug: 'travel',
    name: '旅游风光',
    icon: 'ri-earth-line',
    description: '绝美旅行目的地、自驾攻略、文化探秘，带你云游世界',
    color: 'secondary',
  },
  {
    slug: 'music',
    name: '音乐舞蹈',
    icon: 'ri-music-line',
    description: '热门MV、舞蹈教学、乐器演奏，感受艺术律动之美',
    color: 'accent',
  },
  {
    slug: 'gaming',
    name: '游戏竞技',
    icon: 'ri-gamepad-line',
    description: '游戏实况解说、电竞赛事、攻略秘籍，游戏玩家的聚集地',
    color: 'primary',
  },
];